// eslint-disable no-underscore-dangle
import { cacheAdapterEnhancer } from 'axios-extensions';
import LRUCache from 'lru-cache';
import Vue from 'vue';
import QueryBuilder from '../ModelBinding/QueryBuilder';
import debounce from 'debounce-promise';

export default function ({ $axios }) {
  const defaults = $axios.defaults;

  defaults.adapter = cacheAdapterEnhancer($axios.defaults.adapter, {
    enabledByDefault: false,
    defaultCache: new LRUCache({ maxAge: 1000 * 30, max: 100 }),
  });
}

if (!Vue.__axios_cache_adapter_mixin___) {
  Vue.__axios_cache_adapter_mixin___ = true;
  Vue.mixin({
    beforeCreate() {
      Object.defineProperty(this, '$fetch', {
        get: () => async (...args) => {
          if (!this._$fetch) return null;
          QueryBuilder.forceCacheUpdate = !!this._$fetchedOnce;
          this._$fetchedOnce = true;
          const fetched = await this._$fetch(...args);
          QueryBuilder.forceCacheUpdate = true;
          return fetched;
        },
        set: ($fetch) => {
          this._$fetch = $fetch;
        },
      });
    },
    methods: {
      $refreshData: debounce(async function $refreshData() {
        QueryBuilder.forceCacheUpdate = true;
        return this.$root.refresh();
      }, 1800),
    },
  });
}
